import React, { useState, useEffect } from "react";
import adicionarUser from "../../../../API/Manager/adicionarUser";

import '../../../../styles/desktop/adicionar.css';

export default function Adicionar({ onBack }) {
    const [reportPermissions, setReportPermissions] = useState({
        Sindico: false,
        Administrador: true,
        Construtora: false,
        CMD: false,
    });

    const [fullName, setFullName] = useState(""); // Nome completo
    const [username, setUsername] = useState(""); // Nome de usuário
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showBackButton, setShowBackButton] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBackButton(true);
        }, 500); // Meio segundo (500ms)
    
        return () => clearTimeout(timer); // Limpa o timeout caso o componente seja desmontado
    }, []);

    const resetStatesToDefault = () => {
        setFullName(""); // Redefine o nome completo
        setUsername(""); // Redefine o nome de usuário
        setEmail(""); // Redefine o email
        setPassword(""); // Redefine a senha
        setErrorMessage(""); // Remove mensagens de erro
        setShowConfirmation(false); // Fecha o pop-up de confirmação
    };
    

    const handlePermissionChange = (permission) => {
        setReportPermissions((prev) => ({
            ...prev,
            [permission]: !prev[permission],
        }));
    };

    const compararSenha = (senha) => {
        if (senha === document.getElementById("password").value) {
            setErrorMessage("");
            setPassword(senha);
        } else {
            setErrorMessage("As senhas não coincidem.");
        }
    };

    const handleBackButtonClick = () => {
        setShowBackButton(false);
        setTimeout(() => onBack(), 300);
    };

    const handleSaveChanges = () => {
        setShowConfirmation(true); // Exibe o pop-up de confirmação
    };

    const confirmSaveChanges = async () => {
        setIsSaving(true); // Exibe um estado de carregamento
        if (!fullName || !username || !email || !password) {
            setErrorMessage("Preencha todos os campos.");
            setIsSaving(false);
            setShowConfirmation(false); // Fecha o pop-up de confirmação
            return;
        }

        const storedUser = sessionStorage.getItem("user");
        const condominio = storedUser ? JSON.parse(storedUser).condominio : null;

        if(!condominio) {
            setErrorMessage("Erro ao obter o condomínio, reinicie a aplicação.");
            setIsSaving(false);
            setShowConfirmation(false); // Fecha o pop-up de confirmação
            return;
        }

        try {
            const usuario = {
                user: username, // Nome de usuário
                name: fullName, // Nome completo
                email: email,
                password: password,
                report: reportPermissions,
                condominio: condominio,
                role: "default",
                table: "userdefault",
            };

            await adicionarUser(usuario);

            alert("Usuário adicionar com sucesso!");
            resetStatesToDefault();
        } catch (error) {
            console.error("Erro ao adicionar o usuário:", error);
            alert("Erro ao adicionar o usuário.");
        } finally {
            setIsSaving(false);
            setShowConfirmation(false); // Fecha o pop-up de confirmação
        }
    };

    return (
        <div className="adicionarContent">
            <div className="adicionar-header">
                <h1 className="adicionar-title">Criar usuário</h1>
            </div>
            <div className="adicionar-form adicionar-form-self">
                {errorMessage && <p className="passwordErrorText">{errorMessage}</p>}
                <label className="adicionar-label" htmlFor="fullName">Nome completo:</label>
                <input
                    className="adicionar-input"
                    id="fullName"
                    name="fullName"
                    placeholder="Nome completo"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                />

                <label className="adicionar-label" htmlFor="username">Usuário:</label>
                <input
                    className="adicionar-input"
                    id="username"
                    name="username"
                    placeholder="Crie um nome de usuário"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />

                <label className="adicionar-label" htmlFor="email">E-mail:</label>
                <input
                    className="adicionar-input"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Insira o e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label className="adicionar-label">Senha:</label>
                <input
                    className="adicionar-input"
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Insira a senha"
                />

                <label className="adicionar-label">Confirmar Senha:</label>
                <input
                    className="adicionar-input"
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="Confirme a nova senha"
                    onChange={(e) => compararSenha(e.target.value)}
                />
                <label className="alterar-label">Permissões de Reporte:</label>
                <div className="alterar-checkbox-group">
                    {Object.keys(reportPermissions).map((permission) => (
                        <label key={permission}>
                            <input
                                type="checkbox"
                                checked={reportPermissions[permission]}
                                onChange={() => handlePermissionChange(permission)}
                            />
                            {permission.charAt(0).toUpperCase() + permission.slice(1)}
                        </label>
                    ))}
                </div>
                <div className="adicionar-submit-button" onClick={handleSaveChanges}>
                    Salvar Alterações
                </div>
            </div>
        
            {showConfirmation && (
                <div className="confirmation-popup">
                    <p>Tem certeza que deseja salvar as alterações?</p>
                    <div className="popup-buttons">
                        <button onClick={confirmSaveChanges} disabled={isSaving}>
                            {isSaving ? "Salvando..." : "Sim"}
                        </button>
                        <button onClick={() => setShowConfirmation(false)} disabled={isSaving}>
                            Não
                        </button>
                    </div>
                </div>
            )}
            {showBackButton && (
                <div className="adicionar-back-button fade-in" onClick={handleBackButtonClick}>
                    Voltar
                </div>
            )}
        </div>
    );
}
